export default class NotValidError extends Error {
    constructor(value: string) {
        super(`Date interval value "${value}" is not valid.`);
    }
}


// WEBPACK FOOTER //
// ./src/Models/dateModels/exception/NotValidError.ts